document.addEventListener(`DOMContentLoaded`, () => {
    const containers = document.querySelectorAll(`.faq-section`)
    
    const hideTargets = function (container) {
        if (container instanceof Node) {
            const accordianTargets = container.querySelectorAll(`[data-accordian-target]`)

            accordianTargets.forEach(accordianTarget => {
                accordianTarget.style.display = `none`
            })
        }
    }

    const showTarget = function (targetSelector) {
        const target = document.querySelector(targetSelector)

        if (target instanceof Node) {
            target.style.display = `block`
        }
    }

    if (containers.length > 0) {
        containers.forEach(container => {
            const accordianActions = container.querySelectorAll(`[data-accordian-action]`)
            const accordianTargets = container.querySelectorAll(`[data-accordian-target]`)
            let lastClicked = null

            hideTargets(container)

            accordianActions.forEach(accordianAction => {
                accordianAction.addEventListener(`click`, e => {
                    e.preventDefault()

                    hideTargets(container)

                    if (lastClick !== e.currentTarget) {
                        showTarget(e.currentTarget.getAttribute(`href`))
                        lastClick = e.currentTarget
                    } else {
                        lastClick = null
                    }
                })
            })
        })
    }
})